export const en = {
    reviews: 'reviews',
    filter: 'Filter',
    clearAll: 'Clear all',
    category: 'Category',
    filtersAdded: 'Filters added',
    view: 'View',
    products: 'products',
    search: 'Search',
    onAirToday: 'On Air Today',
    onAirYesterday: 'On Air Yesterday',
    onAirRecently: 'On Air Recently',
};

export const fr = {
    reviews: 'reviews',
    filter: 'Filter',
    clearAll: 'Clear all',
    category: 'Category',
    filtersAdded: 'Filters added',
    view: 'View',
    products: 'products',
    search: 'Search',
    onAirToday: 'On Air Today',
    onAirYesterday: 'On Air Yesterday',
    onAirRecently: 'On Air Recently',
};
